/**
 * Conversion funnel tracker — fire-and-forget POSTs to /api/public/funnel/event.
 * Uses the same anonymous session_id as the A/B framework so the funnel and
 * experiments can be cross-attributed (eventually).
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "xea_ab_session"; // shared with useAbVariant

const getSessionId = () => {
  if (typeof window === "undefined") return "ssr";
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

/**
 * Track a funnel stage. Stage must be one of:
 *   "plan_viewed" | "method_selected" | "checkout_started" | "payment_completed"
 * Optional meta: { tier, method }.
 */
export const trackFunnel = (stage, meta = {}) => {
  try {
    axios.post(`${API}/public/funnel/event`, {
      stage,
      session_id: getSessionId(),
      tier:   meta.tier   || null,
      method: meta.method || null,
    }).catch(() => { /* swallow — analytics must never break a flow */ });
  } catch (_) { /* localStorage disabled etc */ }
};
